import { computed } from 'mobx';

/**
 * 모델
 * @window w_tb_ca602w_01
 * @category 현재고현황
 */

export class BalanceModel {
  /**
   *
   *
   * **data type** varchar(8)
   */
  readonly custcd: string;

  /**
   *
   *
   * **data type** varchar(2)
   */
  readonly spjangcd: string;

  /**
   *
   *
   * **data type** varchar(20)
   */
  readonly pcode: string;

  /**
   *
   *
   * **data type** varchar(60)
   */
  readonly pname: string;

  /**
   *
   *
   * **data type** varchar(60)
   */
  readonly psize: string;

  /**
   *
   *
   * **data type** varchar(10)
   */
  readonly punit: string;

  /**
   *
   *
   * **data type** varchar(0)
   */
  readonly qty: string;

  /**
   *
   *
   * **data type** varchar(0)
   */
  readonly xqty: string;

  /**
   *
   *
   * **data type** varchar(0)
   */
  readonly iqty: string;

  /**
   *
   *
   * **data type** varchar(0)
   */
  readonly cqty: string;

  /**
   *
   *
   * **data type** varchar(0)
   */
  readonly bqty: string;

  /**
   *
   *
   * **data type** varchar(255)
   */
  readonly remark: string;

  /**
   *
   *
   * **data type** varchar(1)
   */
  readonly qty_tot: string;

  /**
   *
   *
   * **data type** varchar(1)
   */
  readonly xqty_tot: string;

  /**
   *
   *
   * **data type** varchar(1)
   */
  readonly iqty_tot: string;

  /**
   *
   *
   * **data type** varchar(1)
   */
  readonly cqty_tot: string;

  /**
   *
   *
   * **data type** varchar(1)
   */
  readonly bqty_tot: string;

  /**
   * 회사코드
   *
   * **data type** varchar(1)
   */
  readonly wkactcd: string;

  /**
   * 회사구분
   *
   * **data type** varchar(1)
   */
  readonly wkactnm: string;

  new: string;

  constructor(data: any = {}, isNew: boolean = false) {
    this.custcd = data.custcd || '';
    this.spjangcd = data.spjangcd || '';
    this.pcode = data.pcode || '';
    this.pname = data.pname || '';
    this.psize = data.psize || '';
    this.punit = data.punit || '';
    this.qty = data.qty || '';
    this.xqty = data.xqty || '';
    this.iqty = data.iqty || '';
    this.cqty = data.cqty || '';
    this.bqty = data.bqty || '';
    this.remark = data.remark || '';
    this.qty_tot = data.qty_tot || '';
    this.xqty_tot = data.xqty_tot || '';
    this.iqty_tot = data.iqty_tot || '';
    this.cqty_tot = data.cqty_tot || '';
    this.bqty_tot = data.bqty_tot || '';
    this.wkactcd = data.wkactcd || '';
    this.wkactnm = data.wkactnm || '';
    this.new = isNew ? '1' : '0';
  }

  @computed
  get isNew() {
    return this.new === '1';
  }
}
